import { render, staticRenderFns } from "./speaker-request.vue?vue&type=template&id=3564a204&scoped=true"
import script from "./speaker-request.vue?vue&type=script&lang=js"
export * from "./speaker-request.vue?vue&type=script&lang=js"
import style0 from "./speaker-request.vue?vue&type=style&index=0&id=3564a204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564a204",
  null
  
)

export default component.exports